module.exports = __webpack_public_path__ + "static/img/298_TO8_1936.25b3375.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/298_TO8_1936.jpg
// module id = 4PxK
// module chunks = 0